// ============================================================================
// SHARED FORM CONSTANTS
// ============================================================================

export const SCHOOL_IS_NOT_LISTED_WARNING =
  "Your school may be listed under a different city name than the one you have selected. Verify the school's address and search again."

export const NOT_LISTED = 'My school is not listed'

export const ASSIGNMENT_CONFIRMATION_MESSAGE =
  "Once you assign this license to the school above, you won't be able to change it. The License Administrator will receive an email with information on how to add user(s) and additional License Administrators to this product."

export const ASSIGNMENT_CONFIRMATION_CHECKBOX_TEXT =
  "I understand that I can't change the school assigned once I submit it."

export const FORM_FIELD_WIDTHS = {
  LABEL: 3,
  FIELD: 9,
} as const

export const FORM_NAMES = {
  ASSIGN_CONFIRM: 'assign-confirm',
  SCHOOL_LOOKUP: 'school-lookup',
} as const
